import React from "react"
import { FcVideoCall } from "react-icons/fc"
import { Link } from "gatsby"
const Interested = () => {
  return (
    <section className="bg-dark pt-5 md:pt-20 pb-16 md:pb-40">
      <div className="max-w-screen-md lg:max-w-screen-lg lg:mx-16 xl:mx-auto mx-auto">
        <div className="h-auto md:mx-10 lg:mx-0 rounded-lg px-6 py-12 md:px-10 md:py-20">
          <div className="text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl text-white pb-3 font-metropolis font-medium">
              Interested in working together?
            </h2>
            <p className="text-sm md:text-lg xl:text-xl text-white font-metropolis font-light pt-3 md:pt-2 tracking-wide">
              Feel free to contact me for any project or collaboration.
            </p>
          </div>
          <div className="flex justify-center mt-12 md:mt-16 lg:mt-20 text-base md:text-lg text-black">
            <Link
              to="https://calendly.com/abhishekgautam/freelance-work"
              target="_blank"
            >
              <button className="flex items-center justify-center text-white border border-white py-3 px-12 font-metropolis font-normal text-base lg:py-4 lg:px-16 hover:bg-yellow-500 hover:border-yellow-500 hover:text-black focus:outline-none transition-all duration-300 ease-linear tracking-wide uppercase">
                <div className="pr-4 md:pr-5">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    version="1"
                    viewBox="0 0 48 48"
                    enable-background="new 0 0 48 48"
                    class="text-3xl"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill=""
                      d="M8,12h22c2.2,0,4,1.8,4,4v16c0,2.2-1.8,4-4,4H8c-2.2,0-4-1.8-4-4V16C4,13.8,5.8,12,8,12z"
                    ></path>
                    <polygon fill="" points="44,35 34,29 34,19 44,13"></polygon>
                  </svg>
                </div>
                Book a free call
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Interested
